import DayRosterSection from './DayRosterSection';

const RequestReportSection = () => {
  return (
    <>
      <DayRosterSection excludingCredit={false} sentToAgency={true} />
    </>
  );
};

export default RequestReportSection;
